import Pagination from '@mui/material/Pagination'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getAll } from 'app/slices/News'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  maxWidth: '250px',
  wordBreak: 'break-all',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 4,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.focus,
  },
  position: 'relative',
}))

const MAX_ITEM_IN_PAGE = 10
export default function NewsTable() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pagination, setPagination] = useState({
    curPage: 1,
    totalPage: 0,
  })
  const list = useAppSelector((s) => s.News.list)
  const lockItem = useAppSelector((s) => s.News.lockItem)
  useEffect(() => {
    if (list.length === 0) dispatch(getAll())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setPagination({
      ...pagination,
      totalPage: Math.ceil(list.length / MAX_ITEM_IN_PAGE),
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPagination({
      ...pagination,
      curPage: value,
    })
  }
  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small" sx={{ minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell>日付</StyledTableCell>
              <StyledTableCell>タグ</StyledTableCell>
              <StyledTableCell>タイトル</StyledTableCell>
              <StyledTableCell>内容</StyledTableCell>
              <StyledTableCell>状態</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {list
              .slice(
                (pagination.curPage - 1) * MAX_ITEM_IN_PAGE,
                pagination.curPage * MAX_ITEM_IN_PAGE
              )
              .map((news, i) => {
                return (
                  <StyledTableRow
                    key={i}
                    onClick={() => {
                      navigate(`/news/${encodeURIComponent(news.id)}`)
                    }}
                    sx={{
                      pointerEvents:
                        lockItem === news.id || !news.active
                          ? 'none'
                          : 'inherit',
                      background: news.active ? 'inherit' : '#999 !important',
                      position: 'relative',
                      '& .MuiTableCell-root': {
                        color: news.active ? 'inherit' : '#bbb !important',
                        pointerEvents:
                          lockItem === news.id || !news.active
                            ? 'none'
                            : 'inherit',
                      },
                    }}
                  >
                    <StyledTableCell>
                      {`${news.id}`.padStart(5, '0')}
                    </StyledTableCell>
                    <StyledTableCell>
                      {format(new Date(news.date), 'yyyy/MM/dd')}
                    </StyledTableCell>
                    <StyledTableCell>{news.tag}</StyledTableCell>
                    <StyledTableCell>{news.title}</StyledTableCell>
                    <StyledTableCell>
                      <div
                        className="ql-snow max-h-40 overflow-auto p-1 rounded"
                        dangerouslySetInnerHTML={{
                          __html: news.content,
                        }}
                        style={{
                          border: '1px solid #ccc',
                        }}
                      ></div>
                    </StyledTableCell>
                    <StyledTableCell>
                      {news.active ? '掲載中' : '削除済'}
                    </StyledTableCell>
                    {lockItem === news.id && (
                      <div
                        className="absolute inset-0 bg-[#30a8] text-white font-bold flex justify-center items-center px-4 z-50"
                        style={{
                          textShadow: '2px 2px 2px #c006',
                        }}
                      >
                        編集中
                      </div>
                    )}
                  </StyledTableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <Stack my={1} alignItems="center">
        <Pagination
          count={pagination.totalPage}
          page={pagination.curPage}
          shape="rounded"
          onChange={handleChange}
        />
      </Stack>
    </>
  )
}
